export default function () {
  return {
    current: {
      id: '',
      name: '',
      days: 0,
      weeks: 0,
      months: 0,
      years: 0,
      systems: []
    },
    update: {
      id: '',
      name: '',
      days: 0,
      weeks: 0,
      months: 0,
      years: 0
    },
    list: []
  }
}
